import { render, staticRenderFns } from "./CariDetailView.vue?vue&type=template&id=6a18fe58&"
import script from "./CariDetailView.vue?vue&type=script&lang=js&"
export * from "./CariDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports